export interface AppConfig {
  ldClientId: string;
  appVersion: string;
}

declare global {
  interface Window {
    __APP_CONFIG__?: Partial<AppConfig>;
  }
}

export const config: AppConfig = {
  ldClientId: window.__APP_CONFIG__?.ldClientId ?? '',
  appVersion: window.__APP_CONFIG__?.appVersion ?? 'dev'
};
